module.exports = __webpack_public_path__ + "static/img/09042B_R_2_3_4_5_6_20180224_fit.d4617ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/09042B_R_2_3_4_5_6_20180224_fit.png
// module id = 4SfP
// module chunks = 0